import * as React from 'react';

import { ChatPlugin } from '@common/react/components/Chat/Chat';
import { useChatSettingsProviderContext } from '@common/react/components/Chat/ChatSettingsProvider';
import { RequestButton } from '@common/react/components/UI/LoadingButton/LoadingButton';

export const ReadAllChatMessagesPlugin: ChatPlugin = {
	chatsListHeaderComponent: () => {
		const {
			state: {
				requests,
			},
		} = useChatSettingsProviderContext();

		return <RequestButton
			requestType={requests.readAllChatMessages}
			className="btn btn-primary load-chats-btn icon-btn"
			title="Read All Chat Messages"
			// to prevent default onSuccess
			onSuccess={() => {}}
		>
			<i className="fa fa-eye" aria-hidden="true" />
		</RequestButton>;
	},
};
